import React from 'react';
import { styled } from 'styled-components';
import { ISkeletonProps, Skeleton } from '../../components/Skeleton/Skeleton';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { Cell, DefaultCellProps } from '../Cell/Cell';

export type SkeletonCellAlignmentOptions = 'start' | 'end';

export type ISkeletonCellProps = DefaultCellProps & { skeleton?: ISkeletonProps } & { alignment?: SkeletonCellAlignmentOptions };

const PositionedSkeleton = styled(Skeleton)<Pick<ISkeletonCellProps, 'alignment'>>`
  display: flex;
  justify-content: ${({ alignment }) => (alignment === 'end' ? 'flex-end' : 'flex-start')};
  align-items: flex-start;
`;

export const SkeletonCell = styled(({ skeleton, alignment = 'end', compact, ...rest }: ISkeletonCellProps) => {
  const { generateTestId } = useTestId(rest, 'SkeletonCell');
  const { skeletonWidth = 64, loaderType = 'singleLine', ...skeletonRest } = skeleton ?? {};
  return (
    <Cell compact={compact} {...rest} {...generateTestId()}>
      <PositionedSkeleton loaderType={loaderType} skeletonWidth={skeletonWidth} alignment={alignment} {...skeletonRest} {...generateTestId('Skeleton')} />
    </Cell>
  );
})``;
